var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchivist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8613 40C80.8613 62.092 62.952 80 40.8613 80C18.7707 80 0.861328 62.092 0.861328 40C0.861328 17.9093 18.7707 0 40.8613 0C62.952 0 80.8613 17.9093 80.8613 40Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7969 25.0092C55.9995 25.0092 57.1035 25.6705 57.6742 26.7305L64.4049 40.9985",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6348 40.9985L24.0588 26.7745C24.6201 25.6905 25.7401 25.0092 26.9601 25.0092",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5781 26.2402V20.8722H53.0928V26.2402",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5234 32.6055V27.2375H55.1501V32.6055",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0039 39.8291V33.5264H57.7172V39.8291",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8613 42.7253V56.7906C16.8613 58.0813 17.908 59.1279 19.2 59.1279H62.5227C63.8147 59.1279 64.8613 58.0813 64.8613 56.7906V42.7253C64.8613 41.4333 63.8147 40.3866 62.5227 40.3866H50.9427C50.3787 40.3866 49.8373 40.6119 49.4413 41.0119L47.1813 43.2906C46.7853 43.6919 46.244 43.9173 45.68 43.9173H36.0427C35.4787 43.9173 34.9387 43.6919 34.5413 43.2906L32.2827 41.0119C31.8867 40.6119 31.3453 40.3866 30.7813 40.3866H19.2C17.908 40.3866 16.8613 41.4333 16.8613 42.7253Z",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4915 52.9966H36.8182C35.7009 52.9966 34.7969 52.0912 34.7969 50.9752C34.7969 49.8579 35.7009 48.9526 36.8182 48.9526H44.4915C45.6089 48.9526 46.5142 49.8579 46.5142 50.9752C46.5142 52.0912 45.6089 52.9966 44.4915 52.9966Z",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivist);
export default __webpack_public_path__ + "static/media/archivist.0de886370208876040255d52805b341c.svg";
export { ForwardRef as ReactComponent };